export const listPropertyStyles = {
  container: {
    backgroundColor: 'secondary.main',
    minHeight: '100vh',
    width: '100%',
  },
  headerContainer: {
    padding: {xs: "20px", lg: "35px 75px"},
    position: 'relative',
    zIndex: 2,
  },
  gridContainer: {
    padding: {xs: 0, lg: "0 75px 75px 75px"},
    position: 'relative',
  },
  cardContainer: {
    boxShadow: {xs: "none", lg: "0px 4px 34px 0px #00000012"},
    borderRadius: "40px",
    height: 'fit-content',
    padding: {xs: 0, lg: "20px"}
  }
};

